"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeCommunicationWebView = exports.initializeCommunicationSubApp = exports.initializeCommunicationFrame = void 0;
const initializer_1 = require("../initializer");
const features_1 = require("../features");
const init_1 = require("../mobileConnector/init");
const initializeCommunicationFrame = (validDomains, API = initializer_1.API) => {
    const eventBus = features_1.EventCollectorContainerFactory.initEventBridge(features_1.FetchEventMap);
    const _XHRServer = new features_1.XHREventDrivenServer(eventBus, API);
    validDomains.forEach(validDomain => {
        const postMessage = features_1.EventCollectorContainerFactory.initPostMessage(features_1.FetchEventMap, validDomain);
        const _XHRServer = new features_1.XHREventDrivenServer(postMessage, API);
    });
    return {
        API,
    };
};
exports.initializeCommunicationFrame = initializeCommunicationFrame;
const initializeCommunicationSubApp = (validDomain, options) => {
    const eventBus = features_1.EventCollectorContentFactory.init(features_1.FetchEventMap, validDomain);
    const API = new features_1.XHREventDrivenClient(eventBus, options);
    return {
        API,
    };
};
exports.initializeCommunicationSubApp = initializeCommunicationSubApp;
const initializeCommunicationWebView = () => {
    const eventBus = features_1.EventCollectorContainerFactory.initEventBridge(features_1.FetchEventMap);
    const _XHRServer = new features_1.NativeEventDrivenServer(eventBus, init_1.getMobileConnector);
};
exports.initializeCommunicationWebView = initializeCommunicationWebView;
//# sourceMappingURL=initializers.js.map